<template>
  <div>
    <div style="display:flex">
      <div style="display:flex;">
        <a-select style="width:110px;margin-top:auto;margin-bottom:auto;font-size:12px;" v-model="controlType" slot="addonAfter" default-value="default">
            <a-select-option value="default">
                <div style="font-size:12px">Bulk actions</div>
            </a-select-option>
            <a-select-option value="edit">
                <div style="font-size:12px">Edit</div>
            </a-select-option>
            <a-select-option value="delete">
                <div style="font-size:12px">Delete</div>
            </a-select-option>
            <a-select-option value="check">
                <div style="font-size:12px">Api Check</div>
            </a-select-option>
            <a-select-option value="uncheck">
                <div style="font-size:12px">Api Uncheck</div>
            </a-select-option>
        </a-select>
          <a-button style="margin-left:2px" slot="enterButton" @click="onApply" type="primary" ghost>
            Apply
          </a-button>
      </div>
      <div style="display:flex;margin-left:15px">
        <a-select style="width:100px;margin-top:auto;margin-bottom:auto;font-size:12px;" v-model="internalFilterDate" slot="addonAfter" default-value="all">
            <a-select-option v-for="item in filterDateList" :key="item.name" :value="item.id">
                <div style="font-size:12px">{{ item.name }}</div>
            </a-select-option>
        </a-select>
        <a-button slot="enterButton" style="margin-left:2px" @click="onFilter" type="primary" ghost>
          Filter
        </a-button>
      </div>

    </div>
    <a-table
      :columns="columns"
      :data-source="hotellist"
      :pagination="tablePagination"
      :row-selection="rowSelection"
      rowKey="_id"
      @change="handleTableChange"
    >
        <a slot="name" slot-scope="text">{{ text }}</a>
        <span slot="customTitle"><a-icon type="smile-o" /> Name</span>
        <span slot="tags" slot-scope="tags">
        <a-tag
            v-for="tag in tags"
            :key="tag"
            :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
        >
            {{ tag }}
        </a-tag>
        </span>
        <!-- <span slot="apiintegrate" slot-scope="text, record">
          <a-checkbox v-model="record.apiintegrate" @change="onChangeApiIntegrate(record)" :disabled="record.hotelcode == undefined || record.hotelcode == ''">
            Integrate
          </a-checkbox>
        </span> -->
        <span slot="hotelHidden" slot-scope="text, record">
          <a-checkbox v-model="record.hotelHidden" @change="onChangeHotelHidden(record)">
            Hidden
          </a-checkbox>
        </span>

        <span slot="hotelCountry" slot-scope="text, record">
          <div>{{record.selectedCountry != undefined ? getCountryNameById(record.selectedCountry) : ''}}</div>
        </span>
        
        <span slot="createdate" slot-scope="text, record">
          <div>{{record.createdate != undefined ? record.createdate.toString().slice(0, 10) : ''}}</div>
        </span>
        <span slot="hotelimage" slot-scope="text, record">
          <img :src="record.hotelimage != '' && record.hotelimage != undefined ? `${record.hotelimage}`:''" alt="" width="50px" height="30px">
        </span>
        <span slot="hotelname" slot-scope="text, record">
          <div style="text-decoration-line: underline;color:#1890ff;cursor: pointer;" @click="clickHotel(record._id)" v-on:click.middle="clickHotel(record._id)">{{text}}</div>
        </span>
        <span slot="action" slot-scope="text, record">
        <!-- <a>Invite 一 {{ record.name }}</a> -->
          <a @click="deleteHotelOne(record._id)">Delete</a>
          <a-divider type="vertical" />
          <a @click="editHotelOne(record)">Edit</a>
          <!-- <a-divider type="vertical" />
          <a v-if="(record.status === 'Pending' || record.status === 'Denied' || record.status === undefined)" @click="AproveUserOne(record.id)">Approve</a>
          <a v-if="(record.status == 'Approved')" @click="DenyUserOne(record.id)">Deny</a> -->
        </span>
    </a-table>
    
    <div style="display:flex;position:absolute;bottom: 10px;z-index: 1;">
      <a-select style="width:170px;margin-top:auto;margin-bottom:auto;margin-left:2px" v-model="filterRoomCount" slot="addonAfter" default-value=0>
          <a-select-option v-for="item in filterRoomList" :key="item.name" :value="item.id">
              <div style="font-size:12px">{{ item.name }}</div>
          </a-select-option>
      </a-select>
      <a-button style="margin-left:2px" slot="enterButton" @click="onFilterCount" type="primary" ghost>
        Filter Count
      </a-button>
    </div>
  </div>
</template>
<script>
import { api } from '../../helpers/Helpers';
var selecetedList = [];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selecetedList = selectedRows;
  },
  onSelect: (record, selected, selectedRows) => {
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
  },
};
const filterDateList = [
  {
    id:'all',
    name:'All dates'
  },
  {
    id:'2022-01-12T14:26:25.599Z',
    name:'March 2022'
  },
  {
    id:'2022-02-12T14:26:25.599Z',
    name:'February 2022'
  },
  {
    id:'2022-03-12T14:26:25.599Z',
    name:'March 2021'
  },
  {
    id:'2022-04-12T14:26:25.599Z',
    name:'April 2022'
  },
  {
    id:'2022-05-12T14:26:25.599Z',
    name:'May 2022'
  },
  {
    id:'2022-06-12T14:26:25.599Z',
    name:'June 2021'
  },
  {
    id:'2022-07-12T14:26:25.599Z',
    name:'July 2022'
  },
  {
    id:'2022-08-12T14:26:25.599Z',
    name:'August 2022'
  },
  {
    id:'2022-09-12T14:26:25.599Z',
    name:'September 2021'
  },
  {
    id:'2022-10-12T14:26:25.599Z',
    name:'October 2022'
  },
  {
    id:'2022-11-12T14:26:25.599Z',
    name:'November 2022'
  },
  {
    id:'2022-12-12T14:26:25.599Z',
    name:'December 2021'
  },
];
const filterSeoScoreList = [
  {
    id:'all',
    name:'All SEO Scores'
  },
  {
    id:'1',
    name:'SEO: Need Improvement'
  },
  {
    id:'2',
    name:'SEO: OK'
  },
  {
    id:'3',
    name:'SEO: Good'
  },
  {
    id:'4',
    name:'SEO: No Focus Keyphase'
  },
  {
    id:'5',
    name:'SEO: Post Noindexed'
  },
];
const filterReadScoreList = [
  {
    id:'all',
    name:'All Readability Scores'
  },
  {
    id:'1',
    name:'Readability: Need Improvement'
  },
  {
    id:'2',
    name:'Readability: OK'
  },
  {
    id:'3',
    name:'Readability: Good'
  },
];
const filterRoomList = [
  {
    id:10,
    name:'10 hotels'
  },
  {
    id:25,
    name:'25 hotels'
  },
  {
    id:50,
    name:'50 hotels'
  },
];
export default {
  data() {
    return {
      controlType:'default',
      internalFilterDate: 'all',
      internalFilterSeoScore: 'all',
      internalFilterReadScore: 'all',
      filterRoomCount: 10,
      rowSelection,
      selecetedList,
      filterDateList,
      filterSeoScoreList,
      filterReadScoreList,
      filterRoomList,
      countryList: [],
    };
  },
  props: {
      hotellist: {
        type: Array,
        default: () => [],
      },
      columns: {
        type: Array,
        default: () => [],
      },
      tableCellCount: {
        type: Number,
        default: 10,
      },
      pagination: {
        type: Object,
        default: () => ({}),
      },
      filterDate: {
        type: String,
        default: 'all',
      },
      filterSeoScore: {
        type: String,
        default: 'all',
      },
      filterReadScore: {
        type: String,
        default: 'all',
      }
  },
  components: {
  },
  
  created: function () {
    this.getCountryList();
    this.internalFilterDate = this.filterDate;
    this.internalFilterSeoScore = this.filterSeoScore;
    this.internalFilterReadScore = this.filterReadScore;
    this.filterRoomCount = this.pagination.pageSize || this.tableCellCount || 10;
  },
  computed: {
    tablePagination() {
      const base = this.pagination || {};
      return {
        showSizeChanger: false,
        ...base,
        current: base.current || 1,
        pageSize: base.pageSize || this.filterRoomCount,
        total: base.total !== undefined ? base.total : (this.hotellist ? this.hotellist.length : 0),
      };
    },
  },
  watch: {
    pagination: {
      handler(newVal) {
        if (newVal && newVal.pageSize && newVal.pageSize !== this.filterRoomCount) {
          this.filterRoomCount = newVal.pageSize;
        }
      },
      deep: true,
    },
    filterDate(newVal) {
      this.internalFilterDate = newVal;
    },
    filterSeoScore(newVal) {
      this.internalFilterSeoScore = newVal;
    },
    filterReadScore(newVal) {
      this.internalFilterReadScore = newVal;
    },
    tableCellCount(newVal) {
      if (newVal && newVal !== this.filterRoomCount) {
        this.filterRoomCount = newVal;
      }
    }
  },
  methods: {
      getHotelList(){
          
      },
      getCountryList:async function(){
        const res = await api.getCountryInfo();
        if (res.length > 0){
           this.countryList = res.sort((a, b) => a.key - b.key)
        }
      },
      getCountryNameById(id) {
        const found = this.countryList.find(c => c._id === id);
        return found ? found.country : '';
      },
      onApply(){
          // console.log(this.controlType)
        if (this.controlType == 'default'){
          return;
        }
        else if (this.controlType == 'edit'){
          this.editHotelApply();
        }
        else if (this.controlType == 'delete'){
          this.deleteHotel();
        }
        else if (this.controlType == 'check'){
          this.checkHotel();
        }
        else if (this.controlType == 'uncheck'){
          this.uncheckHotel();
        }
        
      },
      editHotelApply(){
        if (selecetedList.length > 0)
          this.$router.push({ path: 'edithotel', query: {id:selecetedList[0].id}})

      },
      deleteHotel:async function(){
        if (selecetedList.length <= 0)
          return;
          
        this.$confirm({
          title: 'Do you want to delete these hotels?',
          // content: h => <div style="color:red;">Some descriptions</div>,
          onOk: ()=> {
            this.deleteHotelResult()
          },
          onCancel() {
            
          },
          class: 'test',
        });
      },
      deleteHotelResult:async function(){

        for (let i = 0; i < selecetedList.length; i++) {
          const res = await api.deleteHotel(selecetedList[i]._id);
          // console.log(res, selecetedList[i].id)
        }
        this.$emit('listUpdate');

      },
      
      checkHotel:async function(){
        if (selecetedList.length <= 0)
          return;
          
        for(let i = 0; i < selecetedList.length; i++){
          const res = await api.updateHotel(selecetedList[i]._id, {apiintegrate:true});
          // console.log(res, "-checkHotel--")
        }
        this.$emit('listUpdate');
      },
      uncheckHotel:async function(){
        if (selecetedList.length <= 0)
          return;
          
        for(let i = 0; i < selecetedList.length; i++){
          const res = await api.updateHotel(selecetedList[i]._id, {apiintegrate:false});
          // console.log(res, "-uncheckHotel--")
        }
        this.$emit('listUpdate');
      },

      deleteHotelOne:async function(_id){
       
        // console.log(_id)
        
        this.$confirm({
          title: 'Do you want to delete this hotel?',
          // content: h => <div style="color:red;">Some descriptions</div>,
          onOk: ()=> {
            this.deleteHotelOneResult(_id)
          },
          onCancel() {
            
          },
          class: 'test',
        });
      },
      
      deleteHotelOneResult:async function(_id){

        const res = await api.deleteHotel(_id);
        // console.log(res, _id)
        this.$emit('listUpdate');

      },

      editHotelOne:async function(_info){
        this.$router.push({ path: 'edithotel', query: {id:_info._id} })
        // window.location.href = '/admin/edituser/?id=' + _id;
      },
      
      onFilter(){
        this.$emit('listFilter', {
          date: this.internalFilterDate,
          seoScore: this.internalFilterSeoScore,
          readScore: this.internalFilterReadScore,
        });
      },
      onFilterCount(){
        this.$emit('listFilterCount', this.filterRoomCount);
      },
      clickHotel(_id){
        // console.log("---",_id)
        this.$router.push({ path: 'edithotel', query: {id:_id} })
        // window.open(`/admin/edithotel?id=${_id}`,"_blank");
        // window.location.href = '/admin/edituser/?id=' + _id;
      },
      handleTableChange(pagination, filters, sorter) {
        this.$emit('tableChange', { pagination, sorter });
      },
      onChangeApiIntegrate:async function(data){
        // // console.log(`checked = ${e.target.checked}`);
        // console.log(`checked data=`,data);
        
        const res = await api.updateHotel(data._id, {apiintegrate:data.apiintegrate});
        // console.log(res, "-onChangeApiIntegrate--")
      },
      onChangeHotelHidden:async function(data){
        // // console.log(`checked = ${e.target.checked}`);
        // console.log(`checked data=`,data);
        
        const res = await api.updateHotel(data._id, {hotelHidden:data.hotelHidden});
        // console.log(res, "-onChangeHotelHidden--")
      }
  }
};
</script>